export default {
      id: "oc-res-user-usage",
      viewBox: "0 0 1134 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-user",
      toString: function () {
        return this.url;
      }
    }